import React, { useContext } from "react";
import Cookies from "js-cookie";
import Callback from "@components/callback";
import Context from "@components/useContext/context";
import ACKO_LOGO_URL from "@utils/logo";

interface Props {
  showHelp?: Boolean;
  helpData?: any;
  showBackNavigator?: Boolean;
  showFloatingCallbackCta?: Boolean;
  floatingCallbackCtaStyles?: any;
}

const Header = ({ showHelp, helpData, floatingCallbackCtaStyles }: Props) => {
  const hideHeader = Cookies.get("hide_header") === "true";
  const { canRenderHelp, showChatbot } = useContext(Context);

  return (
    <>
      {!hideHeader ? (
        <div
          className="w-full border-solid  border-b"
          style={{ borderColor: "rgb(230, 234, 240)" }}
        >
          <div
            className="flex justify-between items-center h-12"
            style={{
              maxWidth: "1170px",
              margin: "auto",
              height: "70px"
            }}
          >
            <a href={process.env.HOST_URL}>
              <img
                src={ACKO_LOGO_URL || ""}
                alt="url"
                style={{ width: "auto", height: "28px" }}
              />
            </a>
            {canRenderHelp && showHelp && !showChatbot && (
              <Callback
                helpData={helpData}
                floatingCallbackCtaStyles={floatingCallbackCtaStyles}
              />
            )}
          </div>
        </div>
      ) : null}
    </>
  );
};
export default Header;
